import React from 'react';
import { Route } from 'react-router';

import TopicList from '../containers/TopicList';
import Article from '../containers/ArticlePanel';
import PopularArticles from '../containers/PopularArticles';

import ArticleListByTopic from '../containers/ArticleListByTopic';

import SearchFilterForm from '../containers/SearchFilterForm';
import SearchResult from '../containers/SearchResult';

const routes = [
  { path: '/:experience/home',
    exact: true,
    sideBar: () => <TopicList />,
    mainContainer: () => <PopularArticles />,
  },
  { path: '/:experience/topic/:topicId',
    exact: true,
    sideBar: () => <TopicList />,
    mainContainer: () => <ArticleListByTopic />,
  },
  { path: '/:experience/article/:articleId',
    exact: true,
    sideBar: () => <TopicList />,
    mainContainer: () => <Article />,
  },
  { path: '/:experience/search',
    exact: true,
    sideBar: () => <SearchFilterForm />,
    mainContainer: () => <SearchResult />,
  },
];

const SideBar = () =>
  <div>
    { routes.map(route => (
      <Route
        key={route.path}
        path={route.path}
        exact={route.exact}
        component={route.sideBar}
      />
       ))
     }
  </div>;

const MainContainer = () =>
  <div>
    { routes.map(route => (
      <Route
        key={route.path}
        path={route.path}
        exact={route.exact}
        component={route.mainContainer}
      />
       ))
     }
  </div>;

export default {
  sideBar: <SideBar />,
  mainContainer: <MainContainer />,
};



// WEBPACK FOOTER //
// ./home/routes/LargeScreenRoutes.js